<template>
  <div class="details-wrapper">
    <div class="details-body">
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <TesEmployeeDetailsForm :tes-employee="newTesEmployee" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AppActions } from '@/app/app.keys';
import { NewTesEmployeeGetters } from './new-tes-employee.keys';
import TesEmployeeDetailsForm from '../tes-employee-details/components/TesEmployeeDetailsForm';

export default {
  name: 'TesEmployeesDetails',
  components: { TesEmployeeDetailsForm },

  computed: {
    newTesEmployee() {
      return this.$store.getters[NewTesEmployeeGetters.NewTesEmployee];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('tesEmployees.labels.newTesEmployee'));
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;

  .details-body {
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      flex: 0 85%;
      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px;
      }
    }
  }
}
</style>
